import React, { useState } from 'react';
import { Container, Row, Col, Tab, Tabs, Card, Alert } from 'react-bootstrap';
import ReferralForm from './ReferralForm';
import ReferralHistory from './ReferralHistory';

const Referrals = () => {
  const [activeTab, setActiveTab] = useState('invite');

  return (
    <Container fluid>
      <Row className="mb-4">
        <Col>
          <h2>🚕 Refer a Friend Program</h2>
          <p className="text-muted">
            Invite your colleagues to try Taxi-Local.uk and earn rewards!
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Alert variant="success">
            <h5>💰 How It Works</h5>
            <ul className="mb-0">
              <li>Invite your colleague to try Taxi-Local.uk for 1 month for just £1</li>
              <li>They get access to all professional driver features</li>
              <li>When confirmed as full Member/Subscription, you receive a £25 reward!</li>
              <li>No limit on how many colleagues you can refer</li>
            </ul>
          </Alert>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
              >
                <Tab eventKey="invite" title="Send Invitation">
                  <ReferralForm />
                </Tab>
                <Tab eventKey="history" title="My Referrals">
                  <ReferralHistory />
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Referrals;
